import { get, post, post2, del, put, delDirect, delBody, putBody, postBody, getId, postId } from './request'
const ADMIN = '/admin-template-server'
const CBS = '/cg/cbs'
const SG = '/sg/srs'

export const getAreaList = p => get(ADMIN + '/api/account/login/area/list', p) //获取仪表盘地图数据
export const getDashboaradPie = p => get(ADMIN + '/api/account/source/distribute', p) //获取仪表盘饼图数据
export const getPieStatus = p => get(ADMIN + '/api/account/status/distribute', p) //获取仪表盘状态饼图接口
export const getStatisticList = p => get(ADMIN + '/api/bid/statistic/type', p) //获取仪表盘状态饼图接口
export const getMonitor = p => get(ADMIN + '/api/log/bid/data/statistics', p) //es每日监控列表统计(包括每日推送数量、系统新增数据、网站发布数量)
export const getCRMMonitor = p => get(ADMIN + '/api/log/crm/monitor', p) //获取

export const getStatisticsCount = p => get(ADMIN + '/api/customer/statistics/count', p) //获取
export const getStatistics = p => get(ADMIN + '/api/customer/statistics/distribute', p) //获取

/*修改密码*/
export const checkPassword = p => get(ADMIN + '/api/admin/check/password', p) //检查原密码
export const modifyPassword = p => post(ADMIN + '/api/admin/modify/password', p) //保存密码

// export const goLogin = p => post(ADMIN + '/login', p)
export const outLogin = p => post(SG + '/logout', p)
export const loginStatistics = p => get(ADMIN + '/api/log/login/list', p)
export const getCommonSource = p => get(ADMIN + '/api/customer/source/list', p)
export const getCommonStatus = p => get(ADMIN + '/api/customer/status/list', p)
export const getCustomerNameList = p => get(ADMIN + '/api/customer/name/list', p)
export const getCustomerType = p => get(ADMIN + '/api/customer/type/list', p)
// export const getAccountInfo = p => get(ADMIN + '/api/account/info', p) //用户id检索
export const getCustomerInfo = p => get(ADMIN + '/api/customer/info', p) //客户id检索
export const gotoProduct = p => get(ADMIN + '/simulate/check', p) //跳转对应用户
export const getApplyList = p => get(ADMIN + '/api/apply/list', p) //申请试用管理列表
export const updateApplyUserInfo = p => put(ADMIN + '/api/apply/info', p) //申请试用管理详情修改
export const getApplyUserInfo = p => get(ADMIN + '/api/apply/info', p) //申请试用管理详情修改
export const getAccountStatus = p => get(ADMIN + '/api/account/status', p) //获取账号状态
// export const getAccountBindInfo = p => get(ADMIN + '/api/account/bind/info', p) //获取关联的账号信息
// export const unbindAccount = p => post(ADMIN + '/api/account/unbind/system', p) //解除账号绑定
// export const saveBindSystem = p => post(ADMIN + '/api/account/bind/system', p) //关联账号的保存
export const getAccountNameList = p => get(ADMIN + '/api/account/name/list', p) //接触账号绑定
// export const getUnbindList = p => get(ADMIN + '/api/account/bind/list', p) //点击解绑展示的列表的接口

export const getAdminUsers = p => get(ADMIN + '/api/admin/list', p) //获取后台账号列表
export const searchUserInfo = p => get(ADMIN + '/api/admin/info', p) //查询用户信息
export const disable = p => postId(ADMIN + '/api/admin/disable/', p) //停用启用
export const resetPassword = p => postId(ADMIN + '/api/admin/password/', p) //重置密码
export const getUserInfo = p => getId(ADMIN + '/api/admin/info/', p) //点击编辑获取信息
export const saveInfo = p => post(ADMIN + '/api/admin/info', p) //保存接口
export const getLogCustomerName = p => get(ADMIN + '/api/admin/name/list', p) //日志统计  获取姓名接口
export const getLogList = p => get(ADMIN + '/api/admin/operation/log', p) //日志统计  获取日志列表接口
export const getUserNameList = p => get(ADMIN + '/api/account/name/list', p) //日志统计  获取日志列表接口
/**永森start**/
export const getMenuList = p => get(ADMIN + '/api/admin/menu/list', p) //获取菜单列表
export const getSystemRouter =  p => get(SG + '/api/account/menu/list', p) //查询菜单列表
export const modifyMenu = p => post(ADMIN + '/api/admin/menu/info', p) //新增修改菜单, tips: 有id为修改，没有id为新增
export const deleteMenu = p => del(ADMIN + '/api/admin/menu/info', p) //删除菜单
export const getAllMenu = p => get(ADMIN + '/api/admin/menu/all/list', p) //获取所有菜单列表
export const getUserInfoByCookie = p => get(ADMIN + '/api/admin/info/', p) //点击编辑获取信息
export const getApplySourceList = p => get(ADMIN + '/api/apply/source/list', p) //获取申请试用列表来源下拉框数据
export const getWeChatUserList = p => get(ADMIN + '/api/wechat/user/list', p) //查询微信用户列表
export const getWeChatUserTopic = p => get(ADMIN + '/api/topic/list', p) //查询用户订阅列表
export const whiteInfo = p => post(ADMIN + '/api/wechat/user/honourable', p) //加入移出白名单
export const getWechatLog = p => get(ADMIN + '/api/wechat/related/log', p) //加入移出白名单
export const getWeChatUserExport = p => get(CBS + '/export/list', p) //查询用户导出列表
export const getWeChatExportCount = p => get(CBS + '/export/day/count', p) //微信用户导出列表数据统计
export const getWeChatUserRights = p => get(CBS + '/wechat/right/list', p) //查询用户导出列表
export const getTopicBiddingList = p => get(CBS + '/api/topic/bidding/4mina/list', p) //查询用户订阅列表
export const getCwooTopicBiddingList = p => get(CBS + '/api/customize/topic/bidding/list', p) //查询标讯分析数据列表
export const getTopicWordCloud = p => get(CBS + '/word/cloud', p) //查询订阅主题关键词词云数据
export const getBiddingList = p => post(CBS + '/api/industry/bidding/list', p) //查询招投标数据列表
export const getExportList = p => post(CBS + '/api/customize/bidding/4mina/list', p) //查询导出数据列表
export const getGroupTop = p => get(CBS + '/ent/group', p) //查询招投标行业top10
export const getIndustryList = p => get(CBS + '/ent/industry/list', p) //查询行业列表
export const getGroupList = p => get(ADMIN + '/api/admin/menu/group/list', p) //查询菜单分组列表
export const getEnterpriseList = p => get(CBS + '/ent/list', p) //查询企业列表
export const syncEnterprise = p => post(ADMIN + '/api/ent/info', p) //补充企业库数据
export const getVersionList = p => get(ADMIN + '/api/version/list', p) //查询版本列表
export const updateVersion = p => post(ADMIN + '/api/version/info', p) //新增修改版本信息 type: 1小程序，2cwoo
export const deleteVersion = p => del(ADMIN + '/api/version/info', p) //删除版本信息
export const getCRMCustomerList = p => get(ADMIN + '/api/crm/customer/list', p) //获取客户列表（支持模糊查询）
export const getCCIndustryList = p => get(ADMIN + '/api/bid/crm/industry/list', p) //获取行业列表
export const getCommonAreaList = p => get(CBS + '/common/area/list', p) //获取地区列表
export const getCRMOpportunityList = p => get(ADMIN + '/api/crm/opportunity/list', p) //根据客户id查商机
export const updateOpportunity = p => post(ADMIN + '/api/crm/customer/info', p) //立即更新商机数据
export const getCRMOpportunityProducts = p => get(ADMIN + '/api/crm/opportunity/products', p) //查询商机下的明细（版本和增值包等）
export const getProductVersion = p => get(ADMIN + '/api/product/version', p) //查版本详细内容
export const getProductVersionList = p => get(ADMIN + '/api/product/version/list', p) //查产品线下的版本列表
export const addCustomer = p => post(ADMIN + '/api/customer/info', p) //新建用户
export const updateCustomerInfo = p => put(ADMIN + '/api/customer/info', p) //编辑用户
export const validateCustomerName = p => get(ADMIN + '/api/customer/name/duplicated', p) //校验用户名称是否重复
export const getCustomerLogTypeCount = p => get(ADMIN + '/api/customer/type/history', p) //记录申请状态
export const getCRMSaleList = p => get(ADMIN + '/api/crm/salesman/list', p) //查询销售列表
export const getCustomerAccountList = p => get(ADMIN + '/api/customer/account/list', p) //查询账户列表
export const updateCustomerAccountInfo = p => put(ADMIN + '/api/customer/account/info', p) //修改账户数据
export const getAllBiddingList = p => post(CBS + '/api/customize/bidding/list', p) //查询标讯数据列表
export const addBidding = p => post(ADMIN + '/api/bid/news/supplement/url', p) //查询标讯数据列表
export const hasBidUrl = p => get(CBS + '/bid/url/list', p) //补数据时查es库里是否已经有这条数据
export const getRelatedLogList = p => get(ADMIN + '/api/admin/related/log', p) //查询用户操作业务日志列表
export const validateAccountName = p => get(ADMIN + '/api/account/name/duplicated', p) //校验登录帐号名称是否重复
export const getSupplementList = p => get(ADMIN + '/api/bid/news/supplement/url/list', p) //获取补录数据记录列表
export const getOperationDescList = p => get(ADMIN + '/api/admin/operation/list', p) //获取操作日志描述列表
export const getCustomerApiList = p => get(ADMIN + '/api/app/list', p) //获取api权限管理列表
export const addCustomerApi = p => post(ADMIN + '/api/app/info', p) //api权限管理列表,添加用户
export const getMediaList = p => get(ADMIN + '/api/media/list', p) //获取媒体列表数据
export const getMediaGroup = p => get(ADMIN + '/api/media/field/group', p)
export const getApiLogStatistic= p => get(CBS + '/api/log/statistic', p)
export const getApiCustomer= p => get(ADMIN + '/api/app/customer/name/list', p)//获取api接口调用统计页面，用户下拉数据


/**永森end**/
export const getRoleList = p => get(ADMIN + '/api/admin/role/list', p) //角色权限列表
export const getRolePrivilegeList = p => getId(ADMIN + '/api/admin/role/privilege/', p) //获取当前角色已有的权限{id}  //修改当前角色已有的权限{id}?privIds=1,2
export const getRoleInfo = p => postId(ADMIN + '/api/admin/role/info/', p) //新增用户信息
export const getRolePrivilegeSave = p => postId(ADMIN + '/api/admin/role/privilege/', p) //修改当前角色已有的权限
export const getAllPrivilegeList = p => get(ADMIN + '/api/admin/privilege/all/list', p) //获取后台所有权限列表
/**檀start**/
export const getPrivilegeList = p => get(ADMIN + '/api/admin/privilege/list', p) //获取后台权限列表
export const getPrivilegeInfo = p => getId(ADMIN + '/api/admin/privilege/info/', p) //点击编辑获取信息
export const modifyPrivilegeInfo = p => post(ADMIN + '/api/admin/privilege/info', p) //编辑or新建的保存接口
export const getCustomerVersionList = p => get(ADMIN + '/api/customer/list', p) //获取用户列表
// export const getAccountInfo = p => get(ADMIN + '/api/account/info', p) //用户id检索账号
export const saveAccountInfo = p => post(ADMIN + '/api/account/info', p) //用户修改账号的保存
export const getCustomerValid = p => get(ADMIN + '/api/customer/package/valid', p) //用户id检索账号
export const getAccountList = p => get(ADMIN + '/api/account/list', p) //获取用户账号列表
export const getCrmNameList = p => get(ADMIN + '/api/customer/crm/name/list', p) //获取客户列表
export const getSaleNameList = p => get(ADMIN + '/api/customer/salesman/name/list', p) //获取销售列表
export const getCrmMonitorList = p => get(ADMIN + '/api/log/crm/monitor/list', p) //获取销售列表
export const appValidDay = p => put(ADMIN + '/api/app/validDay', p) //获取销售列表

/**檀end**/

export const getCode = p => post2(SG + '/login/check', p) //获取验证码
export const goLogin = p => post(SG + '/login', p) //登录
export const getAccountInfo = p => get(SG + '/api/account/info', p) //用户信息

export const getStatisticReportCount = p => get(SG + '/api/statistic/report/count', p) //报告数量统计
export const getStatisticAuthorReportCount = p => get(SG + '/api/statistic/author/report/count', p) //用户报告数量统计
export const getStatisticCustomerReportCount = p => get(SG + '/api/statistic/customer/report/count', p) //客户报告数量统计
export const getStatisticDateReportCount = p => get(SG + '/api/statistic/date/report/count', p) //日期报告数量统计






//////////////////
// WEBPACK FOOTER
// ./request/api.js
// module id = 2xDC
// module chunks = 53